import { render, staticRenderFns } from "./TechTransformation.vue?vue&type=template&id=0d855d7b&scoped=true"
import script from "./TechTransformation.vue?vue&type=script&lang=js"
export * from "./TechTransformation.vue?vue&type=script&lang=js"
import style0 from "./TechTransformation.vue?vue&type=style&index=0&id=0d855d7b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d855d7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d855d7b')) {
      api.createRecord('0d855d7b', component.options)
    } else {
      api.reload('0d855d7b', component.options)
    }
    module.hot.accept("./TechTransformation.vue?vue&type=template&id=0d855d7b&scoped=true", function () {
      api.rerender('0d855d7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/businessHome/components/ClientUserWrap/TechTransformation.vue"
export default component.exports